import { useTheme } from '@mui/material';

function usePalette() {
  const { palette } = useTheme();

  return palette;
}

const getCompletedDestinationIcon = () => {
  const palette = usePalette();

  return `
    <svg xmlns="http://www.w3.org/2000/svg" id="completed-destination-mkr" width="47" height="47" viewBox="0 0 47 47" fill="none">
      <path d="M23.5 43.0834L22.7579 43.7536C22.9475 43.9636 23.2171 44.0834 23.5 44.0834C23.7828 44.0834 24.0525 43.9636 24.2421 43.7536L23.5 43.0834ZM23.5 43.0834C24.2421 43.7536 24.2422 43.7535 24.2424 43.7532L24.2431 43.7525L24.2454 43.7499L24.2538 43.7406L24.285 43.7058C24.3122 43.6754 24.3519 43.6307 24.4034 43.5724C24.5064 43.4558 24.6563 43.2847 24.8466 43.0638C25.227 42.6223 25.7689 41.9817 26.4183 41.1815C27.7164 39.5821 29.4487 37.3395 31.1831 34.769C32.9155 32.2013 34.6623 29.2882 35.979 26.3491C37.2898 23.4232 38.2083 20.3977 38.2083 17.625C38.2083 9.49399 31.631 2.91669 23.5 2.91669C15.3689 2.91669 8.79163 9.49399 8.79163 17.625C8.79163 20.3977 9.71012 23.4232 11.0209 26.3491C12.3376 29.2882 14.0844 32.2013 15.8168 34.769C17.5512 37.3395 19.2835 39.5821 20.5816 41.1815C21.231 41.9817 21.7729 42.6223 22.1533 43.0638C22.3436 43.2847 22.4935 43.4558 22.5965 43.5724C22.648 43.6307 22.6878 43.6754 22.7149 43.7058L22.7461 43.7406L22.7545 43.7499L22.7568 43.7525L22.7575 43.7532C22.7577 43.7535 22.7579 43.7536 23.5 43.0834Z" fill="${palette.map.icons.completedDestination.fill}" stroke="white" stroke-width="2" stroke-linejoin="round" />
      <path d="M28.9926 15.9097C28.9926 15.7193 28.9382 15.5561 28.8022 15.4201L27.823 14.4681C27.687 14.3321 27.5238 14.2777 27.3334 14.2777C27.143 14.2777 26.9798 14.3321 26.8438 14.4681L22.519 18.7929L20.1254 16.3993C19.9894 16.2633 19.8262 16.2089 19.6358 16.2089C19.4454 16.2089 19.2822 16.2633 19.1462 16.3993L18.167 17.3513C18.031 17.4873 17.9766 17.6505 17.9766 17.8409C17.9766 18.0313 18.031 18.1945 18.167 18.3305L22.0022 22.1657C22.1382 22.3017 22.3014 22.3561 22.4918 22.3561C22.6822 22.3561 22.8454 22.3017 22.9814 22.1657L28.7478 16.3993C28.911 16.2633 28.9926 16.1001 28.9926 15.9097ZM31.6582 17.6233C31.6582 19.0921 31.3046 20.4793 30.5702 21.7305C29.8358 22.9817 28.8566 23.9609 27.6054 24.6953C26.3542 25.4297 24.9942 25.7833 23.4982 25.7833C22.0022 25.7833 20.6422 25.4297 19.391 24.6953C18.1398 23.9609 17.1606 22.9817 16.4262 21.7305C15.6918 20.4793 15.3382 19.0921 15.3382 17.6233C15.3382 16.1545 15.6918 14.7673 16.4262 13.5161C17.1606 12.2649 18.1398 11.2857 19.391 10.5513C20.6422 9.81692 22.0294 9.46332 23.4982 9.46332C24.967 9.46332 26.3542 9.81692 27.6054 10.5513C28.8566 11.2857 29.8358 12.2649 30.5702 13.5161C31.3046 14.7673 31.6582 16.1545 31.6582 17.6233Z" fill="white" />
    </svg >
  `;
};

const getPlannedDestinationIcon = () => {
  const palette = usePalette();

  return `
    <svg xmlns="http://www.w3.org/2000/svg" id="planned-destination-mkr" width="47" height="47" viewBox="0 0 47 47" fill="none">
      <path d="M23.5 43.0834L22.7579 43.7536C22.9475 43.9636 23.2171 44.0834 23.5 44.0834C23.7828 44.0834 24.0525 43.9636 24.2421 43.7536L23.5 43.0834ZM23.5 43.0834C24.2421 43.7536 24.2422 43.7535 24.2424 43.7532L24.2431 43.7525L24.2454 43.7499L24.2538 43.7406L24.285 43.7058C24.3122 43.6754 24.3519 43.6307 24.4034 43.5724C24.5064 43.4558 24.6563 43.2847 24.8466 43.0638C25.227 42.6223 25.7689 41.9817 26.4183 41.1815C27.7164 39.5821 29.4487 37.3395 31.1831 34.769C32.9155 32.2013 34.6623 29.2882 35.979 26.3491C37.2898 23.4232 38.2083 20.3977 38.2083 17.625C38.2083 9.49399 31.631 2.91669 23.5 2.91669C15.3689 2.91669 8.79163 9.49399 8.79163 17.625C8.79163 20.3977 9.71012 23.4232 11.0209 26.3491C12.3376 29.2882 14.0844 32.2013 15.8168 34.769C17.5512 37.3395 19.2835 39.5821 20.5816 41.1815C21.231 41.9817 21.7729 42.6223 22.1533 43.0638C22.3436 43.2847 22.4935 43.4558 22.5965 43.5724C22.648 43.6307 22.6878 43.6754 22.7149 43.7058L22.7461 43.7406L22.7545 43.7499L22.7568 43.7525L22.7575 43.7532C22.7577 43.7535 22.7579 43.7536 23.5 43.0834Z" fill="${palette.map.icons.plannedDestination.fill}" stroke="white" stroke-width="2" stroke-linejoin="round"/>
      <path d="M23.5 22.5209C20.7975 22.5209 18.6041 20.3275 18.6041 17.625C18.6041 14.9225 20.7975 12.7292 23.5 12.7292C26.2025 12.7292 28.3958 14.9225 28.3958 17.625C28.3958 20.3275 26.2025 22.5209 23.5 22.5209Z" fill="white"/>
    </svg>
  `;
};

const getCompletedStopIcon = () => {
  const palette = usePalette();

  return `
    <svg xmlns="http://www.w3.org/2000/svg" id="completed-stop-mkr" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <g clip-path="url(#clip0_277_5788)">
        <path d="M20.08 9.48C20.08 9.2 20 8.96 19.8 8.76L18.36 7.36C18.16 7.16 17.92 7.08 17.64 7.08C17.36 7.08 17.12 7.16 16.92 7.36L10.56 13.72L7.04 10.2C6.84 10 6.6 9.92 6.32 9.92C6.04 9.92 5.8 10 5.6 10.2L4.16 11.6C3.96 11.8 3.88 12.04 3.88 12.32C3.88 12.6 3.96 12.84 4.16 13.04L9.8 18.68C10 18.88 10.24 18.96 10.52 18.96C10.8 18.96 11.04 18.88 11.24 18.68L19.72 10.2C19.96 10 20.08 9.76 20.08 9.48ZM24 12C24 14.16 23.48 16.2 22.4 18.04C21.32 19.88 19.88 21.32 18.04 22.4C16.2 23.48 14.2 24 12 24C9.8 24 7.8 23.48 5.96 22.4C4.12 21.32 2.68 19.88 1.6 18.04C0.52 16.2 0 14.16 0 12C0 9.84 0.52 7.8 1.6 5.96C2.68 4.12 4.12 2.68 5.96 1.6C7.8 0.52 9.84 0 12 0C14.16 0 16.2 0.52 18.04 1.6C19.88 2.68 21.32 4.12 22.4 5.96C23.48 7.8 24 9.84 24 12Z" fill="${palette.map.icons.completedStop.fill}"/>
        <path d="M20.08 9.48C20.08 9.2 20 8.96 19.8 8.76L18.36 7.36C18.16 7.16 17.92 7.08 17.64 7.08C17.36 7.08 17.12 7.16 16.92 7.36L10.56 13.72L7.04 10.2C6.84 10 6.6 9.92 6.32 9.92C6.04 9.92 5.8 10 5.6 10.2L4.16 11.6C3.96 11.8 3.88 12.04 3.88 12.32C3.88 12.6 3.96 12.84 4.16 13.04L9.8 18.68C10 18.88 10.24 18.96 10.52 18.96C10.8 18.96 11.04 18.88 11.24 18.68L19.72 10.2C19.96 10 20.08 9.76 20.08 9.48Z" fill="${palette.map.icons.completedStop.inside}"/>
      </g>
      <defs>
        <clipPath id="clip0_277_5788">
          <rect width="24" height="24" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  `;
};

const getPlannedStopIcon = () => {
  const palette = usePalette();

  return `
    <svg xmlns="http://www.w3.org/2000/svg" id="planned-stop-mkr" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="10" fill="${palette.map.icons.plannedStop.fill}" stroke="${palette.map.icons.plannedStop.stroke}" stroke-width="4" />
    </svg>
  `;
};

export const getStopIcon = (completed = false) => {
  return completed ? getCompletedStopIcon() : getPlannedStopIcon();
};

export const getDestinationIcon = (completed = false) => {
  return completed ? getCompletedDestinationIcon() : getPlannedDestinationIcon();
};

export const PlannedStopIcon = () => {
  const palette = usePalette();

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <circle
        cx="12"
        cy="12"
        r="7.5"
        fill={palette.map.icons.plannedStop.fill}
        stroke={palette.map.icons.plannedStop.stroke}
        strokeWidth="3"
      />
    </svg>
  );
};

export const CompletedStopIcon = () => {
  const palette = usePalette();

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M18.06 10.11C18.06 9.9 18 9.72 17.85 9.57L16.77 8.52C16.62 8.37 16.44 8.31 16.23 8.31C16.02 8.31 15.84 8.37 15.69 8.52L10.92 13.29L8.28 10.65C8.13 10.5 7.95 10.44 7.74 10.44C7.53 10.44 7.35 10.5 7.2 10.65L6.12 11.7C5.97 11.85 5.91 12.03 5.91 12.24C5.91 12.45 5.97 12.63 6.12 12.78L10.35 17.01C10.5 17.16 10.68 17.22 10.89 17.22C11.1 17.22 11.28 17.16 11.43 17.01L17.79 10.65C17.97 10.5 18.06 10.32 18.06 10.11ZM21 12C21 13.62 20.61 15.15 19.8 16.53C18.99 17.91 17.91 18.99 16.53 19.8C15.15 20.61 13.65 21 12 21C10.35 21 8.85 20.61 7.47 19.8C6.09 18.99 5.01 17.91 4.2 16.53C3.39 15.15 3 13.62 3 12C3 10.38 3.39 8.85 4.2 7.47C5.01 6.09 6.09 5.01 7.47 4.2C8.85 3.39 10.38 3 12 3C13.62 3 15.15 3.39 16.53 4.2C17.91 5.01 18.99 6.09 19.8 7.47C20.61 8.85 21 10.38 21 12Z"
        fill={palette.map.icons.completedStop.fill}
      />
      <path
        d="M18.06 10.11C18.06 9.9 18 9.72 17.85 9.57L16.77 8.52C16.62 8.37 16.44 8.31 16.23 8.31C16.02 8.31 15.84 8.37 15.69 8.52L10.92 13.29L8.28 10.65C8.13 10.5 7.95 10.44 7.74 10.44C7.53 10.44 7.35 10.5 7.2 10.65L6.12 11.7C5.97 11.85 5.91 12.03 5.91 12.24C5.91 12.45 5.97 12.63 6.12 12.78L10.35 17.01C10.5 17.16 10.68 17.22 10.89 17.22C11.1 17.22 11.28 17.16 11.43 17.01L17.79 10.65C17.97 10.5 18.06 10.32 18.06 10.11Z"
        fill={palette.map.icons.completedStop.inside}
      />
    </svg>
  );
};

export const PlannedDestinationIcon = () => {
  const palette = usePalette();

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1526_37553)">
        <circle cx="12" cy="9" r="3" fill="white" />
        <path
          d="M12 22L11.2579 22.6703C11.4475 22.8802 11.7171 23 12 23C12.2829 23 12.5525 22.8802 12.7421 22.6703L12 22ZM12 22C12.7421 22.6703 12.7422 22.6701 12.7424 22.67L12.7429 22.6694L12.7443 22.6679L12.749 22.6627L12.7658 22.6439C12.7753 22.6332 12.7877 22.6194 12.8027 22.6024C12.8104 22.5937 12.8189 22.5841 12.8281 22.5737C12.8819 22.5127 12.9599 22.4238 13.0584 22.3094C13.2554 22.0808 13.5352 21.75 13.8702 21.3372C14.5393 20.5127 15.4332 19.3558 16.329 18.0281C17.2228 16.7032 18.1311 15.1902 18.8189 13.6549C19.5008 12.1328 20 10.5148 20 9C20 4.57772 16.4223 1 12 1C7.57772 1 4 4.57772 4 9C4 10.5148 4.49923 12.1328 5.18115 13.6549C5.86894 15.1902 6.77715 16.7032 7.67104 18.0281C8.56684 19.3558 9.46066 20.5127 10.1298 21.3372C10.4648 21.75 10.7446 22.0808 10.9416 22.3094C11.0401 22.4238 11.1181 22.5127 11.1719 22.5737C11.1988 22.6042 11.2197 22.6277 11.2342 22.6439L11.251 22.6627L11.2557 22.6679L11.2571 22.6694L11.2576 22.67C11.2578 22.6701 11.2579 22.6703 12 22ZM12 10.5C11.1723 10.5 10.5 9.82771 10.5 9C10.5 8.17229 11.1723 7.5 12 7.5C12.8277 7.5 13.5 8.17229 13.5 9C13.5 9.82771 12.8277 10.5 12 10.5Z"
          fill={palette.map.icons.plannedDestination.fill}
          stroke="white"
          strokeWidth="2"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1526_37553">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CompletedDestinationIcon = () => {
  const palette = usePalette();

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1525_37492)">
        <path
          d="M12 22L11.2579 22.6703C11.4475 22.8802 11.7171 23 12 23C12.2829 23 12.5525 22.8802 12.7421 22.6703L12 22ZM12 22C12.7421 22.6703 12.7422 22.6701 12.7424 22.67L12.7429 22.6694L12.7443 22.6679L12.749 22.6627L12.7658 22.6439C12.7753 22.6332 12.7877 22.6194 12.8027 22.6024C12.8104 22.5937 12.8189 22.5841 12.8281 22.5737C12.8819 22.5127 12.9599 22.4238 13.0584 22.3094C13.2554 22.0808 13.5352 21.75 13.8702 21.3372C14.5393 20.5127 15.4332 19.3558 16.329 18.0281C17.2228 16.7032 18.1311 15.1902 18.8189 13.6549C19.5008 12.1328 20 10.5148 20 9C20 4.57772 16.4223 1 12 1C7.57772 1 4 4.57772 4 9C4 10.5148 4.49923 12.1328 5.18115 13.6549C5.86894 15.1902 6.77715 16.7032 7.67104 18.0281C8.56684 19.3558 9.46066 20.5127 10.1298 21.3372C10.4648 21.75 10.7446 22.0808 10.9416 22.3094C11.0401 22.4238 11.1181 22.5127 11.1719 22.5737C11.1988 22.6042 11.2197 22.6277 11.2342 22.6439L11.251 22.6627L11.2557 22.6679L11.2571 22.6694L11.2576 22.67C11.2578 22.6701 11.2579 22.6703 12 22ZM12 10.5C11.1723 10.5 10.5 9.82771 10.5 9C10.5 8.17229 11.1723 7.5 12 7.5C12.8277 7.5 13.5 8.17229 13.5 9C13.5 9.82771 12.8277 10.5 12 10.5Z"
          fill={palette.map.icons.completedDestination.fill}
          stroke="white"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <circle cx="12" cy="9" r="4" fill={palette.map.icons.completedDestination.fill} />
        <path
          d="M14.8047 8.12381C14.8047 8.02658 14.777 7.94325 14.7075 7.8738L14.2075 7.38767C14.138 7.31823 14.0547 7.29045 13.9575 7.29045C13.8603 7.29045 13.7769 7.31823 13.7075 7.38767L11.4991 9.59608L10.2768 8.37382C10.2074 8.30437 10.124 8.27659 10.0268 8.27659C9.92957 8.27659 9.84623 8.30437 9.77679 8.37382L9.27677 8.85995C9.20732 8.92939 9.17954 9.01273 9.17954 9.10995C9.17954 9.20718 9.20732 9.29052 9.27677 9.35996L11.2352 11.3184C11.3046 11.3878 11.388 11.4156 11.4852 11.4156C11.5824 11.4156 11.6657 11.3878 11.7352 11.3184L14.6797 8.37382C14.7631 8.30437 14.8047 8.22104 14.8047 8.12381ZM16.1659 8.99884C16.1659 9.74886 15.9853 10.4572 15.6103 11.0961C15.2353 11.735 14.7353 12.2351 14.0964 12.6101C13.4575 12.9851 12.763 13.1656 11.9991 13.1656C11.2352 13.1656 10.5407 12.9851 9.90179 12.6101C9.26288 12.2351 8.76286 11.735 8.38785 11.0961C8.01284 10.4572 7.83228 9.74886 7.83228 8.99884C7.83228 8.24881 8.01284 7.54046 8.38785 6.90155C8.76286 6.26264 9.26288 5.76262 9.90179 5.38761C10.5407 5.01259 11.2491 4.83203 11.9991 4.83203C12.7491 4.83203 13.4575 5.01259 14.0964 5.38761C14.7353 5.76262 15.2353 6.26264 15.6103 6.90155C15.9853 7.54046 16.1659 8.24881 16.1659 8.99884Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1525_37492">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AffectedAreaIcon = () => {
  const palette = usePalette();

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="0.5"
        y="0.5"
        width="23"
        height="23"
        fill="#F47B20"
        fillOpacity="0.25"
        stroke={palette.map.icons.affectedArea.stroke}
      />
    </svg>
  );
};

export const RouteTraveledIcon = () => {
  const palette = usePalette();

  return (
    <svg width="24" height="4" viewBox="0 0 24 4" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="24" y1="2" y2="2" stroke={palette.map.icons.routeTraveled.stroke} strokeWidth="4" />
    </svg>
  );
};

export const RouteRemainingIcon = () => {
  const palette = usePalette();

  return (
    <svg width="24" height="4" viewBox="0 0 24 4" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 2H24"
        stroke={palette.map.icons.routeRemaining.stroke}
        strokeWidth="4"
        strokeLinejoin="round"
        strokeDasharray="4 4"
      />
    </svg>
  );
};
